import Link from "next/link";
import { urlFor } from "../../../lib/client";
import Image from "next/image";
  
const DefaultFooter = ({footerData, menuData}) => {
  const { footer_logo, leftSide, socials, copy_right } =footerData;
  const { avatar_logo, email, phone } = leftSide[0];
  return (
    <footer
      className="main-footer rel z-1"
      style={{
        backgroundImage: "url(assets/images/footer/footer-bg-shape.png)",
      }}
    >
      <div className="container container-1290">
        <div className="footer-top pt-80 pb-60">
          <div className="row align-items-center">
            <div className="col-lg-4">
              <div className="footer-logo mb-20 wow fadeInRight delay-0-2s animated">
                <Link legacyBehavior href="/">
                  <a>
                    <Image   width={198} height={57} src={urlFor(footer_logo).url()} alt={footer_logo.alt} />
                  </a>
                </Link>
              </div>
            </div>
            <div className="col-lg-8 text-lg-end">
              <div className="social-style-four mb-20 wow fadeInLeft delay-0-2s animated">
                {socials.map((platform, index) => (
                  <a key={index} href={platform.link} >
                  <i className={`fab fa-${platform.platform}`} /> <span> {platform.platform} </span>
                </a>
                ))}
                <a href="#" >
                  <i className={`fab fa-dribbble`} /> <span> Dribble </span>
                </a>
                <a href="#" >
                  <i className={`fab fa-behance`} /> <span> Behance </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-8">
            <div className="footer-left-content pt-80">
              <div className="lets-work mb-50 wow fadeInUp delay-0-2s animated">
                <Image
                width={80} height={80}
                  src={urlFor(avatar_logo).url()}
                  alt="Let's Work Man"
                />
                <span>Let’s Work Together</span>
              </div>
              <div className="footer-contact-info wow fadeInUp delay-0-3s animated">
                <a
                  className="theme-btn style-three"
                  href={`mailto:${email.name}`}
                >
                  {email.name} <i className="far fa-arrow-right" />
                </a>
                <a
                  className="theme-btn style-three phone-number"
                  href={`tel:+12013083212 `}
                >
                   +1 (201) 308-3212 <i className="far fa-arrow-right" />
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="footer-right-content">
              <h4 className="footer-title wow fadeInUp delay-0-2s animated">
                Services
              </h4>
              <div className="footer-widget widget_nav_menu">
                <ul className="list-style-two wow fadeInUp delay-0-3s animated">
                {menuData?.map((item, index) => (
    <li key={index}>
    <div style={{ cursor: "pointer" }} onClick={() => window.open(`solutions/${item?.slug?.current}`, "_blank")} >
     {item.menu_name}
    </div>
  </li>
          ))}
                </ul>
                
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="row align-items-center">
            <div className="col-xl-8 col-lg-6">
              <div className="footer-bottom-menu pt-40 pb-35 rpb-0 wow fadeInRight delay-0-2s animated">
                <ul>
                  <li>
                    <Link legacyBehavior href="/about">
                      <a>About</a>
                    </Link>
                  </li>
                  <li>
                    <Link legacyBehavior href="/contact">
                      Contact
                    </Link>
                  </li>
                  <li>
                    <Link legacyBehavior href="/blog">
                      <a>Read Blogs</a>
                    </Link>
                  </li>
                  <li>
                    <Link legacyBehavior href="/projects">
                      View Projects
                    </Link>
                  </li>
                  <li>
                    <Link legacyBehavior href="/privacy-policy">
                      <a>Privacy Policy</a>
                    </Link>
                  </li>
                  <li>
                    <Link legacyBehavior href="/terms-and-conditions">
                      <a>Term & Conditions</a>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6">
              <div className="copyright-text text-lg-end pt-40 pb-35 rpt-10 wow fadeInLeft delay-0-2s animated">
                <p>
                Copyright @2024, Techquisite All Rights Reserved
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default DefaultFooter;
